import React from 'react';

const WebsiteBackground = ({ template, shopData }) => {
  void template;

  const normalizeLogo = (value) => {
    if (!value) return 'Your Store';
    return String(value)
      .replace('.myshopify.com', '')
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (m) => m.toUpperCase());
  };

  const storeLabel = normalizeLogo(shopData?.shop);
  const cards = Array.from({ length: 6 });

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        width: '100%',
        padding: '18px',
        background: '#dfe3ea',
        boxSizing: 'border-box',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '14px',
          background: '#f4f6fa',
          border: '1px solid #bfc6d4',
          boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.8)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '42px',
            flexShrink: 0,
            padding: '10px 14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: '#e8ecf3',
            borderBottom: '1px solid #c9d0dd',
          }}
        >
          <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#ff5f57' }} />
          <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#febc2e' }} />
          <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#28c840' }} />
          <div
            style={{
              marginLeft: '8px',
              width: '52%',
              maxWidth: '360px',
              height: '22px',
              borderRadius: '999px',
              background: '#ffffff',
              border: '1px solid #d5dbe6',
            }}
          />
        </div>

        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            padding: '16px',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              height: '12px',
              width: '140px',
              background: '#c9cfdb',
              borderRadius: '999px',
              marginBottom: '12px',
            }}
          />
          <div
            style={{
              height: '58px',
              width: '100%',
              borderRadius: '12px',
              background: '#d6dce8',
              marginBottom: '14px',
            }}
          />
          <div
            style={{
              height: '10px',
              width: '70%',
              background: '#cfd5e1',
              borderRadius: '999px',
              marginBottom: '4px',
            }}
          />
          <div
            style={{
              height: '10px',
              width: '50%',
              background: '#cfd5e1',
              borderRadius: '999px',
              marginBottom: '16px',
            }}
          />

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gap: '12px',
            }}
          >
            {cards.map((_, index) => (
              <div
                key={index}
                style={{
                  borderRadius: '10px',
                  background: '#ffffff',
                  border: '1px solid #d8deea',
                  padding: '8px',
                }}
              >
                <div
                  style={{
                    height: '66px',
                    borderRadius: '8px',
                    background: '#e6ebf3',
                    marginBottom: '8px',
                  }}
                />
                <div
                  style={{
                    height: '8px',
                    width: '80%',
                    borderRadius: '999px',
                    background: '#d2d9e6',
                    marginBottom: '6px',
                  }}
                />
                <div
                  style={{
                    height: '8px',
                    width: '50%',
                    borderRadius: '999px',
                    background: '#d2d9e6',
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        <div
          style={{
            flexShrink: 0,
            padding: '10px 16px 12px',
            fontSize: '11px',
            color: '#7f8896',
            letterSpacing: '0.02em',
            borderTop: '1px solid #e2e7f0',
            background: '#f4f6fa',
          }}
        >
          {storeLabel}
        </div>
      </div>
    </div>
  );
};

export default WebsiteBackground;
